interface PageHeaderProps {
    title: string;
    className?: string;
}

export function PageHeader({ title, className = '' }: PageHeaderProps) {
    return (
        <div className={`max-w-6xl mx-auto px-4 mb-12 ${className}`}>
            <h1 className="text-4xl md:text-5xl font-bold uppercase text-primary mb-2">{title}</h1>
            <div className="h-1 w-24 bg-primary"></div>
        </div>
    );
}
